import { render, staticRenderFns } from "./VcForm.vue?vue&type=template&id=536f39f3&lang=pug&"
import script from "./VcForm.vue?vue&type=script&lang=js&"
export * from "./VcForm.vue?vue&type=script&lang=js&"
import style0 from "./VcForm.vue?vue&type=style&index=0&id=536f39f3&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports